import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import { ButtonGroup, GuideTypographyLine } from "../../CellComponent";
import { LastCard } from "../common";

export const Content_14_1_A = [
  Header1("typography_0"),
  Instruction("typography_1"),

  Header1("typography_2"),
  Instruction("typography_3"),
  Instruction("typography_4"),

  Header1("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),

  InstructionWithContent(`typography_8`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 시끄러운 카페 안에서 친구의 목소리에만 집중해 대화한다.",
          },
          {
            text: "B. 책을 읽다가 중요한 전화가 오자, 즉시 독서를 멈추고 통화에 집중한다.",
          },
          {
            text: "C. 재미있는 영화를 보며 두 시간 동안 한 번도 한눈을 팔지 않는다.",
          },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),
  Instruction("typography_13"),
  Instruction("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),

  Header1("typography_17"),
  Instruction("typography_18"),
  Instruction("typography_19"),
  Instruction("typography_20"),

  InstructionWithContent(`typography_21`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 잡념이 떠오른 나를 자책하며 더 억지로 집중하려고 미간을 찌푸린다.",
          },
          {
            text: "B. 잡념이 떠올랐다는 걸 가볍게 알아차리고, 다시 원래 집중하던 곳으로 부드럽게 주의를 옮긴다.",
          },
          { text: "C. 저녁 메뉴를 완벽하게 정한 뒤에 다시 명상으로 돌아온다." },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_22"),
  Instruction("typography_23"),

  ...LastCard,
];
